import Axios, { AxiosRequestConfig, AxiosPromise } from 'axios'
import { ROUTES } from 'constants/routes'
import { useAuthentication } from './useAuthentication'

export interface AxiosRequestConfigWithRequired extends AxiosRequestConfig {
  method?: AxiosRequestConfig['method']
  params?: Omit<AxiosRequestConfig['params'], 'route'> & {
    route: ROUTES | string
  }
}

export interface AuthenticatedAxios {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  <T = any>(config: AxiosRequestConfigWithRequired): AxiosPromise<T>
}
/**
 * 
 * @example ```
 * const d = await Axios({
 *    method: 'get', 
 *    url: 'banan/cake/',
 *    params: {
 *      route: Route.SomeRoute,
 *      ...other url params` 
 *    }
  })
 * ```
 */
export const useAuthenticatedAxios = (): AuthenticatedAxios => {
  const { getToken } = useAuthentication()
  return async (config: AxiosRequestConfigWithRequired) =>
    await Axios({
      ...config,
      headers: {
        Authorization: `Bearer ${getToken()}`,
        ...config.headers
      }
    })
}
